import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetFileDetails, orderLawyerInfoSelector, setPostOrderDetailsInfo } from "../../features/auth/orderLawyerInformationSlice";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import {
  GetBillingDetails,
  GetFirmByUserID,
  manageBillingSelector,
  ProcessCCPayment,
} from "../../features/managebilling/manageBillingSlice";
import { authLoginSelector } from "../../features/auth/authLoginSlice";
import {
  GetProfileDetails,
  profileSelector,
} from "../../features/profile/profileSlice";
import { Link, useNavigate, useParams } from "react-router-dom";
import MethodOfPayment from "./MethodOfPayment";
import SendDocuments from "./SendDocuments";
import { BillingType } from "../../common/constants";
import { SendEmailForSendPolicyDocumentExpress } from "../../features/uploadDocument/uploadDocumentSlice";
import { GetLawyer, lawFirmSelector } from "../../features/lawFirm/lawFirmSlice";
import { GetFileInformation, viewOrderSliceSelector } from "../../features/orders/viewOrderSlice";
import { CheckInvoinceExistsAndDownloadPolicies, DownloadPolicy, GetInvoices, GetPricingInfo, invoiceSelector } from "../../features/invoice/invoiceSlice";
import { languageSelector } from "../../features/language/languageSlice";
import Loader from "../orderStatus/Loader";
import { updateFileStatus } from "../../features/orders/orderSlice";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { formatAmountToTwoDecimals } from "../../common/utils";

const DownloadPolicies = () => {
  const { fileDetailsInfo, postOrderDetailsInfo } = useSelector(orderLawyerInfoSelector);
  const { pricingInfo, loadingInvoice, invoices } = useSelector(invoiceSelector);
  const { id } = useParams();
  const fileID = id - 100000;
  const filenumber = id;
  const navigate = useNavigate();
  const { t } = useTranslation();
  const submittionRef = useRef();

  const [assignedLawyers, setAssignedLawyers] = useState([]);
  const [assistantLawyer, setassistantLawyer] = useState("");
  const [ccDetails, setccDetails] = useState(null);
  const [addNewCreditCard, setaddNewCreditCard] = useState(false);
  const [billing, setBilling] = useState("firm");
  const [ccDailog, setCCDailog] = useState(false);
  const [creditCardRequest, setCreditCardRequest] = useState(null);
  const [paymentMethod, setpaymentMethod] = useState("");
  const [EmailValid, setEmailValid] = useState(true);

  const dispatch = useDispatch();
  const { firmIDAndName, billingDetails, loading, CCPaymentResponse } = useSelector(
    manageBillingSelector
  );
  const uploadDocSliceLoading = useSelector((state) => state.uploadDocument.loading);
  const orderSummarySliceLoading = useSelector((state) => state.orderSummary.loading);
  const manageBillingSliceLoading = useSelector((state) => state.manageBilling.loading);
  const { userLogin } = useSelector(authLoginSelector);
  const { profileDetails } = useSelector(profileSelector);
  const { lawyerDetails } = useSelector(lawFirmSelector)
  const lang = useSelector(languageSelector);




  const tdStyle = {
    padding: '10px',
    width: 'max-content',
    backgroundColor: '#FAE094'
  };

  const downloadPoliciesClick = () => {
    let request = {
      FileID: fileID,
      PaymentType: formValues?.paymentType,
      FirmID: firmIDAndName?.firmID || 0,
      FirmName: firmIDAndName?.firmName || "",
      CCTransactionID: CCPaymentResponse?.transactionID,
      CCTransactionLogID: CCPaymentResponse?.ccTransactionLogIds
    };
    dispatch(DownloadPolicy(request, userLogin?.userId));
  };

  function emailValidation(val) {
    const regex =
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (regex.test(val) === false || val === "") {
      setEmailValid(false);
      return false;
    }
    setEmailValid(true);
    return true;
  }

  useEffect(() => {
    dispatch(GetFirmByUserID(userLogin?.userId));
    if (!userLogin?.isLawyer) {
      if (profileDetails?.lawyers?.length > 0) {
        setAssignedLawyers(
          profileDetails?.lawyers?.map((lawyers, index) => ({
            value: lawyers?.userId,
            label: lawyers?.lawyerWithActive,
          }))
        );
        if (profileDetails?.lawyers?.length === 1) {
          setassistantLawyer(profileDetails?.lawyers[0]?.userId);
        }
      } else {
        dispatch(GetProfileDetails(userLogin?.userId, userLogin?.isLawyer));
      }
    }
  }, [profileDetails?.lawyers]);

  useEffect(() => {
    if (!lawyerDetails || lawyerDetails === null) {
      dispatch(GetLawyer(userLogin?.userId))
    }
    if (!fileDetailsInfo || fileDetailsInfo === null) {
      dispatch(GetFileDetails(parseInt(fileID)));
    }
    dispatch(GetFileInformation(parseInt(fileID)))
    dispatch(updateFileStatus(fileDetailsInfo?.fileID, 'Ready For Pickup', userLogin?.userId));
    dispatch(setPostOrderDetailsInfo({
      fileID: fileDetailsInfo?.fileID,
      fileNumber: fileDetailsInfo?.fileNumber,
      dealType: postOrderDetailsInfo?.dealType,
      fileStatus: 'Ready For Pickup',
    }));

    let pricingRequest = {
      IsOnline: 0,
      FileId: fileID,
      QuoteId: null,
      OrderDiscount: null
    }
    dispatch(GetPricingInfo(pricingRequest, userLogin?.userId, { toast }));
    dispatch(GetInvoices(fileID, userLogin?.userId));
  }, []);

  useEffect(() => {
    if (firmIDAndName?.firmID > 0)
      dispatch(
        GetBillingDetails(
          firmIDAndName?.firmID,
          userLogin?.isLawyer ? userLogin?.userId : assistantLawyer,
          userLogin?.userId
        )
      );
  }, [firmIDAndName?.firmID]);

  useEffect(() => {
    if (firmIDAndName !== null) {
      setBilling(firmIDAndName?.hasFirmBilling ? "firm" : "lawyer");
      //dispatch(GetPaymentInformation(userLogin?.userId, firmIDAndName?.firmID, 3, billing));
    }
  }, [firmIDAndName]);

  useEffect(() => {

    if (firmIDAndName)
      setccDetails(
        billingDetails?.paymentInformation?.filter(
          (x) => x.paymentMethod === "Credit Card Payment"
        )
      );
  }, [billingDetails, firmIDAndName]);

  useEffect(() => {
    if (userLogin && userLogin.internalUser) //&& firmIDAndName?.firmName
    {
      dispatch(CheckInvoinceExistsAndDownloadPolicies(fileID, userLogin?.userId, { downloadPoliciesClick }));
    }
  }, [userLogin])

  const handlDropdownChange = (name, val) => {
    if (val) {
      setValue(name, val);
      trigger(name);
    }
  };

  const handleChangeCheckbox = (e) => {
    e.persist();
    setValue(e.target.name, e.target.checked);
    trigger(e.target.name);
  };

  const handleChange = (e) => {
    e.persist();
    if (e.target.name === "NewEmail") {
      emailValidation(e.target.value)
    }
    setValue(e.target.name, e.target.value);
    trigger(e.target.name);
  };

  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    getValues,
    trigger,
    control,
    formState: { errors, isValid },
  } = useForm({
    mode: "onBlur",
  });

  const formValues = getValues();
  watch("CCType");


  let dealtypeID = postOrderDetailsInfo?.dealType?.toLowerCase() === "residential" ? 1 : 2;

  useEffect(() => {
    if (
      billingDetails &&
      billingDetails?.paymentMethodSetUp !== undefined &&
      billingDetails?.paymentMethodSetUp?.length > 0
    ) {
      if (
        billingDetails?.paymentInformation?.filter((x) => x.isAllDealType)
          .length > 0
      ) {
        let allDealDetails = billingDetails?.paymentMethodSetUp?.filter(
          (x) => (x.dealType === 3)
        )[0];
        if (
          billingDetails?.paymentInformation?.filter((x) => x.isAllDealType)[0]
            ?.id === allDealDetails?.billingID
        ) {
          // setValue(`payment.${0}.paymentMethod`, allDealDetails ? allDealDetails?.billingID : 0)
          // setValue(`payment.${0}.billing`, allDealDetails ? allDealDetails?.billingTypeID.toString() : '')

          var PrefferredBillingTypes = BillingType?.PrefferredBillingType;
          if (allDealDetails?.billingTypeID?.toString() !== "0") {
            var paymentmethod = PrefferredBillingTypes?.find(
              (x) => x.value === allDealDetails?.billingTypeID?.toString()
            )?.option;
            setpaymentMethod(paymentmethod.toString());
          }
        } else {
          // setValue(`payment.${0}.paymentMethod`, 0)
          // setValue(`payment.${0}.billing`, '')
          // setValue(`payment.${0}.frequency`, '')
          // setValue(`payment.${0}.dealType`, 0)
        }
      } else {
        let allDealDetails = billingDetails?.paymentMethodSetUp?.filter(
          (x) => (x.dealType === dealtypeID)
        )[0];
        if (
          billingDetails?.paymentInformation?.filter((x) => x?.id === allDealDetails?.billingID)) {
          // setValue(`payment.${0}.paymentMethod`, allDealDetails ? allDealDetails?.billingID : 0)
          // setValue(`payment.${0}.billing`, allDealDetails ? allDealDetails?.billingTypeID.toString() : '')

          var PrefferredBillingTypes = BillingType?.PrefferredBillingType;
          if (allDealDetails?.billingTypeID?.toString() !== "0") {
            var paymentmethod = PrefferredBillingTypes?.find(
              (x) => x.value === allDealDetails?.billingTypeID?.toString()
            )?.option;
            setpaymentMethod(paymentmethod?.toString());
          }
        }
      }
    }
  }, [billingDetails]);

  return (
    <>
      <ToastContainer />
      <div className="bg-[#F5F5ED] flex flex-col px-[190px]">
        <div className="flex flex-row mt-10 mb-10 pt-[41px]">
          <div className="flex flex-flow border-l-box-stroke mr-[50px]">
            <p className="font-normal self-center font-montserrat mr-3">
              {t("Type")}
            </p>
            <h2 className="font-semibold font-open-sans text-[20px]">
              {t(`${postOrderDetailsInfo?.dealType}`)}
            </h2>
          </div>
          <div className="flex flex-flow border-l-box-stroke mr-[50px]">
            <p className="font-normal self-center font-montserrat mr-3">
              {t("StatusM")}
            </p>
            <h2 className="font-semibold font-open-sans text-[20px]">
              {t(`${postOrderDetailsInfo?.fileStatus}`)}
            </h2>
          </div>
          <div className="flex flex-flow border-l-box-stroke mr-[50px]">
            <p className="font-normal self-center font-montserrat mr-3">
              {t("Order")}
            </p>
            <p className="font-semibold font-open-sans text-[20px]">
              {postOrderDetailsInfo?.fileNumber}
            </p>
          </div>
        </div>
        {userLogin !== null && userLogin.internalUser && (
          <div id="internalSection1">
            <div className="font-semibold">
              {t('AdjudicatedStatement')}
            </div>
            <div className="float-right mb-5">
              <button
                onClick={() =>
                  navigate(`/order/${postOrderDetailsInfo.fileNumber}`)
                }
                className="btn__primary flex flex-row gap-[8px] h-[40px] items-center justify-center w-auto pl-6 pr-6"
              >
                <img
                  src="/images/edit_order_icon.f5245d81.svg"
                  alt="Edit Order"
                />
                {t("EditOrderButton")}
              </button>
            </div>
          </div>
        )}

        <div>
          <div className="border-[#d9d9d9] border-[1px] flex flex-col font-open-sans rounded-[2px]">
            <div className="bg-[#FAE094] border-[#dbdada] border-b flex flex-row font-semibold leading-[21.79px] px-[32px] py-[14px] w-full">
              <div className="w-[66%]">{t("FeeDescription")}</div>
              <div className="text-end w-[7%]">#</div>
              <div className="text-end w-[15%]">{t("Rate")}</div>
              <div className="text-end w-[12%]">{t("Total")}</div>
            </div>
            {pricingInfo?.pricingInfoItems?.map((item, index) => (
              <>
                <div className="px-[32px]">
                  <div className="flex flex-row leading-[21.79px] pb-[16px] pt-[14px] w-full">
                    <div className="w-[66%]">{lang?.value === "fr" ? item?.typeOfPolicyFR : item?.typeOfPolicy}</div>
                    <div className="text-end w-[7%]">{item?.quantity}</div>
                    <div className="text-end w-[15%]">{formatAmountToTwoDecimals(item?.amount)}</div>
                    <div className="text-end w-[12%]">{formatAmountToTwoDecimals(item?.amount)}</div>
                  </div>
                </div>
                <hr className="border-line-thin w-full" />
              </>
            ))}





            <div className="" style={{ display: 'flex', justifyContent: 'flex-end', padding: '20px', textAlign: 'left' }}>


              <table className="border-[#d9d9d9] border-[1px] mt-1 mb-1 ">

                <tbody>
                  <tr>
                    <td style={tdStyle} className="font-[600] w-[12%]"> {t('Premium')}</td>
                    <td style={tdStyle} />
                    <td style={tdStyle}>{formatAmountToTwoDecimals(pricingInfo?.pricingAfterDiscount?.subTotal)}</td>
                  </tr>
                  <tr>
                    <td style={tdStyle} className="font-[600]">{t('TotalTax')}</td>
                    <td style={tdStyle} />

                    <td style={tdStyle}>{formatAmountToTwoDecimals(pricingInfo?.pricingAfterDiscount?.tax)}</td>
                  </tr>
                  <tr>
                    <td style={tdStyle} className="font-[600]">{t('Subtotal')}</td>
                    <td style={tdStyle} />

                    <td style={tdStyle}>{formatAmountToTwoDecimals(pricingInfo?.pricingAfterDiscount?.total)}</td>
                  </tr>
                 {pricingInfo?.eliteFee > 0 && (
                  <tr>
                    <td style={tdStyle} className="font-[600] flex ">  {t('EliteFeeService')}</td>
                    <td style={tdStyle} />

                    <td style={tdStyle}>{formatAmountToTwoDecimals(pricingInfo?.eliteFee)}</td>
                  </tr>)}
                  <tr>
                    <td style={tdStyle}><strong> {t('NetDue')}</strong></td>
                    <td style={tdStyle} />

                    <td style={tdStyle}><strong>{formatAmountToTwoDecimals(pricingInfo?.netAmountDue)}</strong></td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>

          {/* internal user screen */}
          {userLogin !== null && userLogin.internalUser && pricingInfo?.pricingInfoItems?.length > 0 && (
            <SendDocuments
              t={t}
              register={register}
              formValues={formValues}
              handleChange={handleChange}
              handleChangeCheckbox={handleChangeCheckbox}
              errors={errors}
              ccDetails={ccDetails}
              loading={loading}
              dispatch={dispatch}
              SendEmailForSendPolicyDocumentExpress={SendEmailForSendPolicyDocumentExpress}
              EmailValid={EmailValid}
              fileID={fileID}
              userID={userLogin?.userId}
              setValue={setValue}
            />
          )}
          {/* method of payment */}
          {userLogin !== null && !userLogin.internalUser && pricingInfo?.pricingInfoItems?.length > 0 && (
            <>
              {paymentMethod === "On Account (Self-Administered)" && (
                <MethodOfPayment
                  t={t}
                  register={register}
                  formValues={formValues}
                  // fields={fields?.filter(x=>x.cardnumber!==undefined)}
                  ccDetails={ccDetails}
                  setaddNewCreditCard={setaddNewCreditCard}
                  handlDropdownChange={handlDropdownChange}
                  setValue={setValue}
                  trigger={trigger}
                  firmIDAndName={firmIDAndName}
                  billing={billing}
                  setCCDailog={setCCDailog}
                  setCreditCardRequest={setCreditCardRequest}
                  submittionRef={submittionRef}
                  paymentMethod={paymentMethod}
                  billingDetails={billingDetails}
                  watch={watch}
                  addNewCreditCard={addNewCreditCard}
                  handleChange={handleChange}
                  handleChangeCheckbox={handleChangeCheckbox}
                  dispatch={dispatch}
                  ProcessCCPayment={ProcessCCPayment}
                  lawyerDetails={lawyerDetails}
                  userID={userLogin?.userId}
                  fileID={fileID}
                  dealtypeID={dealtypeID}
                  downloadPoliciesClick={downloadPoliciesClick}
                  dueAmount={pricingInfo?.netAmountDue}
                  invoices={invoices}
                  userLogin={userLogin}
                  pricingInfo={pricingInfo}
                />
              )}
              {paymentMethod !== "On Account (Self-Administered)" && (invoices === null || invoices === undefined) && (//(invoices?.invoicesResponse === null || invoices?.invoicesResponse === undefined)
                <div className="mt-2">
                  <Link to={`/policypickup/${postOrderDetailsInfo?.fileNumber}`}>
                    <button
                      className="btn__primary px-[16px] py-[9px] mt-4 mb-4 mr-4"
                      onClick={() => {
                        downloadPoliciesClick();
                      }}
                      disabled={invoices?.length > 0}//invoices?.invoicesResponse !== null
                    >
                      {t((pricingInfo?.pricingInfoItems) ? "DownloadPolicies" : "DownloadPolicy")}
                    </button>
                  </Link>
                </div>
              )}
            </>
          )}
        </div>
        {loading || loadingInvoice || uploadDocSliceLoading || orderSummarySliceLoading || manageBillingSliceLoading ? <Loader /> : ''}
      </div>
    </>

  );
};

export default DownloadPolicies;
